import { usersApi } from '@app/services'

import { FetchUserResponse } from './types'

export const fetchUserById = async (userId: number) => {
  const { data } = await usersApi.get<FetchUserResponse>(`/users/${userId}`)

  return data
}
